<template>
    <modal-crud
        title="Editar Aplicação"
        v-on:close="$emit('close')"
        :isLoading="isLoading">
        
        <section class="modal-card-body">
            <!-- Nome -->
            <b-field label="Nome">
                <b-input
                    type="text"
                    placeholder="Nome"
                    v-model="scope.scope"
                    required>
                </b-input>
            </b-field>

            <!-- MFA Ativado -->
            <b-field label="MFA Ativado">
                <b-switch
                    v-model="mfa_ativado"
                    type="is-success"
                    passive-type="is-danger"
                    true-value="1"
                    false-value="0"
                >
                    {{ mfa_ativado === '1' ? 'Ativado' : 'Desativado' }}
                </b-switch>
            </b-field>
        </section>

        <div slot="buttons">
            <b-button
                label="Salvar"
                type="is-primary"
                @click="update" />
        </div>
    </modal-crud>
</template>


<script>
import { Component, Prop, Vue } from 'vue-property-decorator';
import ModalCrud from '@/components/Layout/ModalCrud.vue';
import state from '@/modules/auth/store/state';
import services from '@/http';

@Component({
    components: {
        "modal-crud": ModalCrud,
    },
})
export default class Edit extends Vue {
    @Prop({ default: {} }) scope
    @Prop({ default: {} }) aplicacao

    data() {
        return {
            isLoading: false,
            mfa_ativado: '0', // valor padr�o
        }
    }

    created() {
        // Preenche o switch com valor atual da aplica��o
        this.mfa_ativado = this.aplicacao.MfaAtivado?.toString() || '0';
    }

    update() {

        const data = {
            application_id: this.aplicacao.AplicacaoID,
            application_name: this.aplicacao.Aplicacao,
            userId: state.user.id,
            mfa_ativado: Number(this.mfa_ativado) 
        };

        this.isLoading = true;

        services.application.edit(data)
            .then(res => {
                this.$root.flashSuccess('Alterado com sucesso!');
                this.$emit('close');
                this.$emit('refreshList');
            })
            .catch(err => {
                this.$root.flashError(err);
            })
            .finally(() => {
                this.isLoading = false;
            });
    }
}
</script>
